import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  continue: {
    defaultMessage: 'Continue',
    id: 'KD6lRu',
    description: 'Continue button',
  },
  back: {
    defaultMessage: 'Back',
    id: '2XH9oW',
    description: 'Back button',
  },
});
